import { Component } from '@angular/core';

@Component({
  templateUrl: './renew.component.html',
  styleUrls: ['./renew.component.css'],
})
export class RenewComponent {

  constructor() { }

}
